import { useState, useEffect } from "react";
import s1 from "../assets/gallery/slider/s1.jpeg";
import s2 from "../assets/gallery/slider/s2.jpeg";
import s3 from "../assets/gallery/slider/s3.jpeg";
import s4 from "../assets/gallery/slider/s4.jpeg";
import s5 from "../assets/gallery/slider/s5.jpeg";
import s6 from "../assets/gallery/slider/s6.jpeg";

import introVideo from "../assets/gallery/video/park.mp4";
import introVideo2 from "../assets/gallery/video/park2.mp4";

import room1 from "../assets/gallery/rooms/room1.jpeg";
import room2 from "../assets/gallery/rooms/room2.jpeg";
import room3 from "../assets/gallery/rooms/room3.jpeg";
import room4 from "../assets/gallery/rooms/room4.jpeg";
import cafe1 from "../assets/gallery/rooms/cafe1.jpeg";
import cafe2 from "../assets/gallery/rooms/cafe2.jpeg";
import Card from "./Cards";

const HomePage = () => {
  const sliderImages = [s1, s2, s3, s4, s5, s6];
  const sliderVideo = [introVideo, introVideo2];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentVideo, setCurrentVideo] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [sliderImages.length]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideo((prev) => (prev + 1) % sliderVideo.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [sliderVideo.length]);
  const testimonials = [
    {
      text: "Çok güzel insanlar güler yüzlü ve çok ilgililer kesinlikle tavsiye ediyorum.",
      name: "Ayşe Yılmaz",
      role: "2 Çocuk Annesi",
      avatar: "👩",
    },
    {
      text: "Oyun oynamak için gerçekten güzel bir mekan olmuş. Hem ortam rahat hem de oyun seçenekleri çeşitli.",
      name: "Ferhan Aksoy",
      role: "1 Çocuk Annesi",
      avatar: "👩",
    },
    {
      text: "Çok beğendik, çalışanlar çok güler yüzlüydü. Temizlik konusunda hassas olmaları da ayrıca çok güzeldi.",
      name: "Zeynep Demir",
      role: "3 Çocuk Annesi",
      avatar: "👩",
    },
    {
      text: "Güler yüz, kaliteli ortam.",
      name: "Aytaç Hayta",
      role: "2 Çocuk Babası",
      avatar: "👨",
    },
    {
      text: "Çocuklar için çok keyifli bir ortam, favori mekanımız oldu.",
      name: "Oğuzhan Çınar",
      role: "1 Çocuk Babası",
      avatar: "👨",
    },
  ];

  return (
    <div className="min-h-screen">
      {/* SLIDER */}
      <section className="relative w-full h-[500px] overflow-hidden mt-24">
        {sliderImages.map((img, index) => (
          <img
            key={index}
            src={img}
            alt=""
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
              index === currentSlide ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}

        <div className="absolute inset-0 bg-black/40"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white z-10">
          <h1 className="text-5xl md:text-6xl font-black mb-4">
            Little Winners
          </h1>
          <p className="text-xl md:text-2xl font-semibold">
            Çocuklar için eğlence, güven ve mutluluk
          </p>
        </div>

        <button
          onClick={() =>
            setCurrentSlide(
              currentSlide === 0 ? sliderImages.length - 1 : currentSlide - 1
            )
          }
          className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white text-black text-3xl w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition z-20"
        >
          ‹
        </button>

        <button
          onClick={() =>
            setCurrentSlide((currentSlide + 1) % sliderImages.length)
          }
          className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/70 hover:bg-white text-black text-3xl w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition z-20"
        >
          ›
        </button>
      </section>

      {/* MEKANDAN KARELER */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-black text-center mb-12 text-gray-800">
            Mekanımızdan Kareler 📸
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <Card
              image={room1}
              title="Oyun Alanı"
              desc="Çocukların özgürce koşup oynayabileceği geniş ve güvenli alan."
            />
            <Card
              image={room3}
              title="Oyun Alanı"
              desc="Enerjisini atabileceği eğlenceli ve renkli oyun alanları."
            />
            <Card
              image={room4}
              title="Oyun Alanı"
              desc="Her yaşa uygun güvenli oyun alanları."
            />
            <Card
              image={room2}
              title="Oyun Alanı"
              desc="Güvenli ve hijyenik oyun alanları."
            />
            <Card
              image={cafe2}
              title="Kafe Alanı"
              desc="Ailelerin rahatça dinlenebileceği konforlu alan."
            />
            <Card
              image={cafe1}
              title="Kafe Alanı"
              desc="Çay, kahve ve atıştırmalıklarla keyifli mola alanı."
            />
          </div>
        </div>
      </section>
      {/* YORUMLAR */}
      <section className="py-20 bg-gradient-to-br from-pink-100 to-yellow-100">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-black text-center mb-12 text-pink-600">
            Aileler Ne Diyor? 💬
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="bg-gradient-to-br from-pink-400 to-pink-600 text-white p-8 rounded-3xl shadow-xl hover:-translate-y-2 hover:shadow-2xl transition-all"
              >
                <p className="italic mb-6 leading-relaxed">"{t.text}"</p>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-2xl">
                    {t.avatar}
                  </div>
                  <div>
                    <div className="font-bold">{t.name}</div>
                    <div className="text-sm opacity-90">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
